import React, { Component } from 'react';
import { Grid, Icon, Form, Segment, Button, Header } from 'semantic-ui-react';
import Loading from '../Loading';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { searchClientByValues } from '../../utils/rest';
import ReactTable from 'react-table';
import { NotificationManager } from 'react-notifications';

const initialState = {
    clientId: "",
    clientName: "",
    city: "",
    state: "",
    zipcode: "",
    businessClass: "",
    lastDateContacted: "",
    lastDateReferral: "",
    clientNAD: ""
}

class SearchClient extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchClient: initialState,
            searchResult: [],
            loading: false
        }
    }

    componentDidMount() {
        this.props.addItem("helpFile", "search_client.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e, evt) => {
        this.setState({
            searchClient: {
                ...this.state.searchClient,
                [evt.name]: evt.value
            }
        })
    }

    reset = () => {
        this.setState({
            searchClient: initialState,
            searchResult: []
        })
    }

    validateFields = () => {

        const {clientId, clientName, city, state, zipcode, businessClass, lastDateContacted, lastDateReferral, clientNAD} = this.state.searchClient;

        if(clientId != "" || clientName != "" || city != "" || state != "" || zipcode != "" || businessClass != "" || 
            lastDateContacted != "" || lastDateReferral != "" || clientNAD != ""){
            return true;
        }

        return false;
    }

    searchClient = (e) => {
        e.preventDefault();
        if(this.validateFields()){
            this.setState({
                loading: true
            }, () => {
                searchClientByValues(this.state.searchClient).then((response) => {
                    if (response !== null) {
                        this.setState({
                            loading: false,
                            searchResult: response
                        })
                    }
                }).then((error) => {
                    this.setState({ loading: false })
                })
            })
        }else{
            NotificationManager.error('', 'Please enter value(s) to search.');
        }
    }

    viewClientDetails = (clientId) => {
        window.open("/#/clientAction?clientId=" + clientId);
    }

    handleKeypress = e => {
        if (e.keyCode === 13 || e.which === 13) {
            this.searchClient(e)
        }
    };
    
    
    render() {
        if (this.state.loading) {
            return (<Loading />)
        }
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Client Management" child={[{ name: "Search Client", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment inverted className="grey">
                                    <Header as="h4">Search Client</Header>
                                </Segment>
                                <Segment>
                                    <Form className="small">
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={4}>
                                                    <Form.Input label='Client#:' placeholder='Client Id' name="clientId" onKeyPress={this.handleKeypress} value={this.state.searchClient.clientId} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <Form.Input label='Client Name:' placeholder='Client Name' name="clientName" onKeyPress={this.handleKeypress} value={this.state.searchClient.clientName} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4} >
                                                    <Form.Input label='Business Class:' placeholder='Business Class' name="businessClass" onKeyPress={this.handleKeypress} value={this.state.searchClient.businessClass} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <Form.Input label='Last date Contacted:' placeholder='mm/dd/yyyy' type="date" name="lastDateContacted" onKeyPress={this.handleKeypress} value={this.state.searchClient.lastDateContacted} onChange={this.handleChange} />
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Field width={4} >
                                                    <Form.Input label='Last Date of Referral:' placeholder='mm/dd/yyyy' type="date" name="lastDateReferral" onKeyPress={this.handleKeypress} value={this.state.searchClient.lastDateReferral} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4} >
                                                    <Form.Input label='Next Activity Date:' placeholder='mm/dd/yyyy' type="date" name="clientNAD" onKeyPress={this.handleKeypress} value={this.state.searchClient.clientNAD} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <Form.Input label='City:' placeholder='city' name="city" value={this.state.searchClient.city} onKeyPress={this.handleKeypress} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <Form.Input label='State:' placeholder='State' maxLength='2' name="state" value={this.state.searchClient.state} onKeyPress={this.handleKeypress} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4} >
                                                    <Form.Input label='Zip Code:' placeholder={this.props.t("zipcode")} name="zipcode" value={this.state.searchClient.zipcode} onKeyPress={this.handleKeypress} onChange={this.handleChange} />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Form.Group>
                                            <Form.Field width={16}>
                                                <Button secondary className="small right floated" onClick={this.reset}>
                                                    Reset
                                                </Button>
                                                <Button secondary className="small right floated" onClick={this.searchClient}>
                                                    <Icon name="search"></Icon>
                                                    Search
                                                </Button>
                                            </Form.Field>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                    {this.state.searchResult && this.state.searchResult.length > 0 && 
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment.Group horizontal>
                                    <Segment color="grey" inverted>
                                        <Header as="h4">
                                            <Icon name="cog" />
                                            <div className="content">
                                                Clients
                                            </div>
                                        </Header>
                                    </Segment>
                                </Segment.Group>
                            </Segment.Group>
                            <div className="table-responsive">
                                <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.searchResult && this.state.searchResult.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -highlight "
                                    data={this.state.searchResult}
                                    getNoDataProps={() => {
                                        return { style: { display: 'none' } };
                                    }}

                                    columns={[{
                                        Header: props => <span data-inverted="" data-position="bottom left"># </span>, 
                                        sortable: true, 
                                        maxWidth: 50,
                                        filterable: false, 
                                        Cell: row =>  row.index + 1
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='Client Id' data-position="bottom left">Client Id</span>,
                                        accessor: 'clientId',
                                        sortable: true
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='Client Name' data-position="bottom left">Client Name</span>,
                                        accessor: 'clientName',
                                        Cell: row => ( <div data-inverted="" data-position="bottom left">{row.original.clientName}</div> ),
                                        sortable: true
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='Business Class' data-position="bottom left">Business Class</span>,
                                        accessor: 'businessClass',
                                        sortable: true
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='Last Date Contacted' data-position="bottom right">Last Date Contacted</span>,
                                        accessor: 'lastDateContacted',
                                        sortable: true
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='Last Date Referral' data-position="bottom right">Last Date Referral</span>,
                                        accessor: 'lastDateReferral',
                                        sortable: true
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='Next Activity Date' data-position="bottom right">Next Activity Date</span>,
                                        accessor: 'clientNAD',
                                        sortable: true
                                    }, {
                                        Header: props => <span data-inverted="" data-tooltip='View Client Details' data-position="bottom right">{this.props.t("actions")}</span>,
                                        filterable: false,
                                        maxWidth: 80,
                                        style: {
                                            textAlign: "center"
                                        },
                                        Cell: row => (
                                            <Button className="ui icon mini button" onClick={() => { this.viewClientDetails(row.original.clientId) }} data-inverted="" data-tooltip='View Client Details' data-position="top right">
                                                <Icon name="eye" />
                                            </Button>
                                        )
                                    }]}
                                />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    }
                </Grid>
            </div>
        )
    }

}

export default SearchClient;


// WEBPACK FOOTER //
// ./src/app/ui/client/SearchClient.js